//TODO : Refactor after ai
import type { HTMLAttributes } from "react";
import type { FilterChip } from "../types";
import { Button } from "./Button";
import { Chip } from "./Chip";

export interface FiltersProps extends HTMLAttributes<HTMLDivElement> {
  filters?: FilterChip[];
  onRemove?: (filter: FilterChip) => void;
  onClear?: () => void;
  onAdd?: () => void;
  addLabel?: string;
  clearLabel?: string;
}

/** Row of applied-filter chips with a clear-all action. */
export function Filters({
  filters = [],
  onRemove,
  onClear,
  onAdd,
  addLabel = "+ Filter",
  clearLabel = "Alle entfernen",
  className = "",
  ...rest
}: FiltersProps) {
  if (filters.length === 0 && !onAdd) return null;

  return (
    <div
      className={className}
      style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}
      {...rest}
    >
      {filters.map((f) => (
        <Chip
          key={f.id}
          size="sm"
          selected={f.active}
          onRemove={onRemove ? () => onRemove(f) : undefined}
        >
          {f.field ? (
            <>
              <span style={{ color: "var(--text-tertiary)" }}>{f.field}</span>
              &nbsp;{f.label}
            </>
          ) : (
            f.label
          )}
        </Chip>
      ))}
      {onAdd && (
        <Button size="xxs" variant="ghost" color="neutral" onClick={onAdd}>
          {addLabel}
        </Button>
      )}
      {filters.length > 0 && onClear && (
        <Button size="xxs" variant="link" color="neutral" onClick={onClear}>
          {clearLabel}
        </Button>
      )}
    </div>
  );
}
